import React from 'react';
import PropTypes from 'prop-types';

import { colorGray } from 'styles/layout/colors';

const IconNotifications = ({
  className = '',
  color = colorGray,
  height = 48,
  width = 48,
}) => (
  <svg
    className={className}
    fill="none"
    height={height}
    viewBox="0 0 48 48"
    width={width}
  >
    <path
      d="M14.586 33.4393H34.0264C35.8814 33.4372 37.5542 32.3193 38.2643 30.605C38.9724 28.8908 38.5811 26.9178 37.2706 25.6052L34.3763 22.713V18.0693C34.3763 14.4711 32.4571 11.148 29.3413 9.34921C26.2255 7.55039 22.3872 7.55013 19.2713 9.34921C16.1554 11.1483 14.2363 14.4712 14.2363 18.0693V22.713L11.342 25.6073V25.6052C10.0315 26.9178 9.64026 28.8908 10.3483 30.605C11.0584 32.3193 12.7312 33.4372 14.5862 33.4393L14.586 33.4393ZM13.5902 27.8536L17.4162 24.0256V18.0695C17.4162 14.2642 20.5009 11.1795 24.3062 11.1795C28.1114 11.1795 31.1962 14.2642 31.1962 18.0695V24.0256L35.0221 27.8516V27.8536C35.4258 28.2573 35.5459 28.8619 35.3285 29.3898C35.1091 29.9156 34.5956 30.2593 34.0263 30.2593H14.5859C14.0166 30.2593 13.5031 29.9156 13.2837 29.3898C13.0663 28.8619 13.1864 28.2573 13.5901 27.8536L13.5902 27.8536Z"
      fill={color}
    />
    <path d="M20.0664 36.6172H28.5464V39.7972H20.0664V36.6172Z" fill={color} />
  </svg>
);

IconNotifications.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default IconNotifications;
